export const BASE_WORKSPACE_CAPABILITIES = {
  tier: 'base', multi_workspace_enabled: false, max_owned_workspaces: 1,
  sharing_enabled: false, max_shared_workspaces: 0, max_unique_guests: 0,
  max_guests_per_workspace: 0, guest_subscription_policy: 'not_required',
};

export function workspaceFeatures(plan) {
  if (!plan?.workspace_capabilities) return [];
  const c = { ...BASE_WORKSPACE_CAPABILITIES, ...plan.workspace_capabilities };
  const labels = [`${c.max_owned_workspaces} ${c.max_owned_workspaces === 1 ? 'tablero' : 'tableros'}`];
  if (c.sharing_enabled) labels.push(
    `Hasta ${c.max_shared_workspaces} tableros compartidos`,
    `Comparte con ${c.max_unique_guests} personas en total`,
    `Hasta ${c.max_guests_per_workspace} invitados por tablero`,
    c.guest_subscription_policy === 'active_paid' ? 'Invitados con suscripción activa' : 'Invitados sin suscripción propia',
  );
  return labels;
}
